export const createDialogOpenChangeHandler =
  (onOpen: () => void, onClose: () => void) => (open: boolean) => {
    if (open) {
      onOpen();
    } else {
      onClose();
    }
  };

export const createDialogCloseOnlyHandler =
  (onClose: () => void) => (open: boolean) => {
    if (!open) {
      onClose();
    }
  };
